import React, { RefObject } from "react";

import * as css from "./styles";

export const EmptyMessage: React.FC<{ ref?: RefObject<HTMLDivElement | null>; message?: React.JSX.Element | string }> = ({
  message,
  ref
}) => {
  return (
    <div ref={ref} className={css.messageCls}>
      {message ?? "Du har ingen nye notifikationer"}
    </div>
  );
};
